import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentHYCSVerifyIdentityData,
  type EnrollmentHYCSVerifyIdentitySubmitOutput,
} from '../../../../models'

export const getEnrollmentHYCSVerifyIdentityDataMock: EnrollmentHYCSVerifyIdentityData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-identity',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentHYCSVerifyIdentityDataMock: EnrollmentHYCSVerifyIdentitySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/employment',
}

export const mockGetEnrollmentHYCSVerifyIdentityData = graphql.mutation('getEnrollmentHYCSVerifyIdentityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSVerifyIdentityDataMock } })
})

export const mockSubmitEnrollmentHYCSVerifyIdentityData = graphql.mutation(
  'submitEnrollmentHYCSVerifyIdentityData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSVerifyIdentityDataMock } })
  },
)

export const mockEnrollmentHYCSVerifyIdentity = [
  mockGetEnrollmentHYCSVerifyIdentityData,
  mockSubmitEnrollmentHYCSVerifyIdentityData,
]
